import React from "react";

import {
  LeftOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  RightOutlined,
  SaveOutlined
} from "@ant-design/icons";
import { FormStepsActions } from "../../Redux";
import { Button, Alert, Steps } from "antd";
import { Form, Field, FormSpy } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";

import { FormFieldType, FormField } from "../FormField";
import ExtraCheckModal from "./ExtraCheckModal";
import { i18, trb, CustomIcon, translationGroups, Logout } from "../../Utilities";

const Step = Steps.Step;
const ButtonGroup = Button.Group;
const Condition = ({ when, is, children, all, alwaysShow = null }) => (
  <>
    {when !== undefined ? (
      <Field name={when} subscription={{ value: true }}>
        {({ input: { value } }) =>
          is.length !== undefined
            ? is.indexOf(value) !== -1
              ? children
              : alwaysShow
            : is == value
            ? children
            : alwaysShow
        }
      </Field>
    ) : (
      <>{children}</>
    )}
  </>
);

var Permissons = true;

const FormFieldFill = (item, itemIndex, values, arrIndex = null) => {
  let addonBeforeField;
  if (item.addonBefore && Object.keys(item.addonBefore)) {
    addonBeforeField = (
      <FormField
        className={item.addonBefore.className}
        title={item.addonBefore.title}
        label={item.addonBefore.label}
        name={
          arrIndex !== null
            ? item.addonBefore.name.replace("$index", arrIndex)
            : item.addonBefore.name
        }
        component={item.addonBefore.component}
        maxLength={item.addonBefore.maxLength}
        disabled={Permissions ? item.addonBefore.disabled : true}
        validate={Permissions ? item.addonBefore.validate : null}
      />
    );
  }
  const getName = arrIndex !== null ? item.name.replace("$index", arrIndex) : item.name;

  if (item.disabledCondition) {
    let disableValue = false;
    for (let i = 0; i < item.disabledCondition.length; i++) {
      const keys = item.disabledCondition[i].attr.split(".");
      let obj = values;
      for (let j = 0; j < keys.length; j++) {
        if (obj) {
          obj = obj[keys[j]];
        }
      }
      if (obj && item.disabledCondition[i].valuesIs.includes(obj)) {
        disableValue = true;
      }
    }
    item.disabled = disableValue;
  }
  const resetValues = obj => {
    const keys = getName.split(".");
    let j = 0;
    obj = values;
    for (j = 0; j < keys.length - 1; j++) {
      if (obj) {
        obj = obj[keys[j]];
      }
    }
    if (obj) {
      obj[keys[j]] = "";
    }
  };
  const checkDisplayItem = () => {
    if (item.showWhen && (item.showIs || item.hideIs) && values) {
      const showwhenRep =
        arrIndex !== null ? item.showWhen.replace("$index", arrIndex) : item.showWhen;
      let keys = showwhenRep.split(".");
      if (keys) {
        let obj = values;
        let j = 0;
        for (j = 0; j < keys.length - 1; j++) {
          if (obj) {
            obj = obj[keys[j]];
          }
        }
        if (item.hideIs) {
          if (obj && obj[keys[j]] && item.hideIs.includes(obj[keys[j]])) {
            resetValues(obj);
            return false;
          }
          return true;
        }
        if (obj && obj[keys[j]] && item.showIs && item.showIs.includes(obj[keys[j]])) {
          return true;
        }
        resetValues(obj);
        return false;
      }
      return false;
    }
    return true;
  };
  return !checkDisplayItem() ? (
    <div />
  ) : (
    <FormField
      key={itemIndex}
      className={
        arrIndex == 0 && item.disabled && Permissons
          ? "duplicate-disabled mx-0 " + item.className
          : "mx-0 " + item.className
      }
      classNameTitle={item.classNameTitle}
      classNameField={item.classNameField}
      classNameError={item.classNameError}
      checkedNumber={item.checkedNumber !== false}
      title={item.title}
      label={item.label}
      translate={item.translate}
      name={getName}
      component={item.component}
      componentOptions={item.componentOptions}
      formatNumber={item.formatNumber}
      addonBefore={item.addonBefore && addonBeforeField ? addonBeforeField : item.addonBeforeText}
      inline={item.inline}
      options={
        item.optionsFunction?.(item.optionsFunctionParams, values, item.options) ||
        item.options ||
        []
      }
      optionsLabel={item.optionsLabel}
      optionsLabelImg={item.optionsLabelImg}
      optionsValue={item.optionsValue}
      optionsDisabled={item.optionsDisabled}
      validate={Permissons ? item.validate : null}
      disabled={Permissons ? (arrIndex > 0 && item.duplicateEnabled ? false : item.disabled) : true}
      maxLength={item.maxLength}
      maxDate={item.maxDate}
      minDate={item.minDate}
      initialValue={item.initialValue}
      parse={item.parseFunc}
    />
  );
};

export class KYCFormSwitchWithSteps extends React.Component {
  constructor(props) {
    super(props);

    const propCurrentStep = props.afterLastStep
      ? props.mapData.length
      : props.initialStep
      ? props.initialStep
      : 0;

    this.state = {
      currentStep: propCurrentStep,
      data: null,
      sizePointer: this.checkViewSize(),
      reload: false,
      hideDescriptions: [],
      lastFiledFormStep: propCurrentStep,
      isExtraCheckModalVisible: false,
      allowNextStep: [0, 2]
    };

    this.kycFormWithStepsRef = React.createRef();

    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.onStepClickHandle = this.onStepClickHandle.bind(this);
    this.onExtraCheckModalOk = this.onExtraCheckModalOk.bind(this);
    this.onExtraCheckModalCancel = this.onExtraCheckModalCancel.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.language !== prevProps.language)
      this.setState({
        reload: !prevState.reload
      });
    if (this.props.afterLastStep !== prevProps.afterLastStep) {
      this.setState({
        currentStep: this.props.mapData.length
      });
    }
  };

  updateDimensions = () => {
    this.setState({
      sizePointer: this.checkViewSize()
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  close = () => {
    this.setState({ open: false });
    Logout();
  };

  checkViewSize = () => {
    const width = window.innerWidth;
    if (width > 1200) {
      return 3;
    } else if (width > 900) {
      return 2;
    } else if (width > 500) {
      return 1;
    } else {
      return 0;
    }
  };

  nextStep = values => {
    //TODO this next button
    const { data, allowNextStep, currentStep } = this.state;
    const newData = { ...data, ...values };
    if (allowNextStep.includes(currentStep)) {
      this.setState({
        isExtraCheckModalVisible: true,
        allowNextStep: allowNextStep.filter(item => item !== currentStep),
        data: newData
      });
      setTimeout(() => {
        document.body.scrollTop = 0;
        if (!allowNextStep.includes(currentStep)) this.doNextStep(newData);
      }, 300);
    } else {
      this.doNextStep(newData);
    }
  };

  doNextStep = values => {
    document.body.scrollTop = 0;
    const { lastFiledFormStep } = this.state;
    const { data } = this.state,
      newData = { ...data, ...values };
    this.setState(prevState => ({
      currentStep: prevState.currentStep + 1,
      lastFiledFormStep:
        lastFiledFormStep < prevState.currentStep + 1 ? lastFiledFormStep + 1 : lastFiledFormStep,
      data: newData
    }));
    this.props.onStepSubmit(newData);
    if (this.state.currentStep >= 0) {
      this.props.dispatch(
        FormStepsActions.sendFormApplicationAction({
          data: { personData: newData, currentStep: this.state.currentStep }
        })
      );
    }
  };

  prevStep = () => {
    document.body.scrollTop = 0;
    this.setState(prevState => ({
      currentStep: prevState.currentStep - 1
    }));
    if (this.state.currentStep !== 0) {
      this.props.dispatch(
        FormStepsActions.sendFormApplicationAction({
          data: { personData: this.state.data, currentStep: this.state.currentStep }
        })
      );
    }
  };

  hideDescription = () => {
    const { hideDescriptions, currentStep } = this.state;
    this.setState({
      hideDescriptions: [...this.state.hideDescriptions, currentStep]
    });
  };

  onStepClickHandle = event => {
    if (event > this.state.lastFiledFormStep || event === this.state.currentStep) return;
    document.body.scrollTop = 0;
    if (event > this.state.currentStep && this.state.hasValidationErrors) {
      this.kycFormWithStepsRef.current.dispatchEvent(new Event("submit", { cancelable: true }));
      return;
    }
    this.setState(prevState => ({
      currentStep: event
    }));
  };

  onExtraCheckModalCancel = () => {
    this.setState({ isExtraCheckModalVisible: false });
  };

  onExtraCheckModalOk = () => {
    this.setState({ isExtraCheckModalVisible: false });
    this.doNextStep(this.state.data);
  };

  getExtraCheckData = () => {
    const { data, currentStep } = this.state;
    let newData = {};
    if (currentStep === 0) {
      const newDataAddress = data.clientAddress.filter(item => item.addressType === "ADRT2");
      newData = Object.assign(newDataAddress[0].data);
      newData.clientPhoneNo = data.clientPhone[0].data.clientPhoneNo;
      newData.clientEmail = data.clientMail[0].data.clientEmail;
    }
    if (currentStep === 2) {
      newData = Object.assign(
        data.clientCeo[0].data,
        data.clientRep.length > 0 ? data.clientRep[0].data : null
      );
    }
    return newData;
  };

  render() {
    let approveSubmit = false;
    Permissons = true; // this.props.permissons;

    const {
        sizePointer,
        currentStep,
        hideDescriptions,
        hasValidationErrors,
        isExtraCheckModalVisible
      } = this.state,
      { mapData, submit, initialData, decorators, title, afterLastStep } = this.props,
      maxSteps = mapData.length - 1;
    return (
      <div
        className={`${sizePointer === 3 ? "flex-row" : "flex-column"} d-flex`}
        style={{ width: "100%" }}
      >
        <Steps
          size="small"
          direction={sizePointer === 3 ? "vertical" : "horizontal"}
          style={sizePointer === 3 ? { maxWidth: 200, height: 600, marginRight: 50 } : {}}
          className={`form-stepper ${sizePointer > 1 ? "mb-3" : "mb-3 bbs_kyc_smalleststeps"}`}
          current={currentStep}
          labelPlacement="vertical"
        >
          {mapData &&
            mapData.map((row, rowIndex) => (
              <Step
                title={sizePointer > 1 ? trb(row.title) : null}
                key={rowIndex}
                onStepClick={this.onStepClickHandle}
                disabled={currentStep === 8}
                icon={
                  <CustomIcon
                    type="custom"
                    size={28}
                    icon={
                      rowIndex < currentStep
                        ? "stepCheck"
                        : rowIndex == currentStep
                        ? "stepActive"
                        : "stepInactive"
                    }
                  />
                }
              />
            ))}
        </Steps>

        {afterLastStep ? (
          <>{afterLastStep}</>
        ) : (
          <div className={`form bbs_kyc_form d-flex bbs_kyc_form_step_${currentStep}`}>
            <Form
              onSubmit={currentStep === maxSteps ? submit : this.nextStep}
              initialValues={initialData}
              decorators={Permissons ? decorators : null}
              debug={debugState => {
                if (!debugState.active && debugState.hasValidationErrors != hasValidationErrors)
                  this.setState({ hasValidationErrors: !hasValidationErrors });
              }}
              /*              debug={state => {
                if (state.hasValidationErrors && !state.active) {
                  setTimeout(() => {
                    const list = document.getElementsByClassName('has-error');
                    if (list && list.length > 0)
                      document
                        .getElementsByClassName('has-error')[0]
                        .scrollIntoView();
                  }, 1000);
                }
              }}*/
              mutators={{
                ...arrayMutators
              }}
              render={({
                handleSubmit,
                form: {
                  mutators: { push, pop }
                },
                values,
                form
              }) => {
                return (
                  <form
                    ref={this.kycFormWithStepsRef}
                    className="mb-3"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <div className="row mb-3 form-main-row">
                      {title && <div className="col-12 form-part-title">{trb(title)}</div>}
                      {mapData &&
                        mapData.map((part, partIndex) => (
                          <React.Fragment key={partIndex}>
                            {currentStep === partIndex &&
                              part &&
                              part.rows &&
                              part.rows.map((row, rowIndex) => (
                                <Condition when={row.showWhen} is={row.showIs}>
                                  <div
                                    className={`with_border form-part-wrapper ${
                                      row.className ? row.className : "col-12"
                                    }`}
                                    key={rowIndex}
                                  >
                                    <div className="row">
                                      {row.title && (
                                        <div className="col-12 form-part-title">
                                          {trb(row.title)}
                                        </div>
                                      )}
                                      {row.messageBefore && (
                                        <div className="col-12 mb-3">
                                          <div className="form-part-description col-12 mb-3 eb_fs_18">
                                            {trb(row.messageBefore)}
                                          </div>
                                          {false && (
                                            <Alert
                                              message={trb(row.messageBefore)}
                                              type="info"
                                              showIcon
                                            />
                                          )}
                                        </div>
                                      )}
                                      {row.noteFirst && (
                                        <div className="col-12 mb-3">
                                          <div className="form-part-description col-12 mb-3 eb_fs_18">
                                            * {trb(row.noteFirst)}
                                            <br />
                                            {row.noteSecond && "** " + trb(row.noteSecond)}
                                          </div>
                                        </div>
                                      )}
                                      {row.canDuplicate ? (
                                        <FieldArray name={row.duplicateName}>
                                          {({ fields }) =>
                                            fields.map((arrName, arrIndex) => (
                                              <React.Fragment key={arrIndex}>
                                                <Condition
                                                  when={
                                                    row.showWhen
                                                      ? row.showWhen.replace("$index", arrIndex)
                                                      : row.showWhen
                                                  }
                                                  is={row.showIs}
                                                  alwaysShow={
                                                    row.elements &&
                                                    row.elements
                                                      .filter(item => item.alwaysShow)
                                                      .map((item, itemIndex) =>
                                                        FormFieldFill(
                                                          item,
                                                          itemIndex,
                                                          values,
                                                          arrIndex
                                                        )
                                                      )
                                                  }
                                                >
                                                  {row.elements &&
                                                    row.elements.map((item, itemIndex) =>
                                                      FormFieldFill(
                                                        item,
                                                        itemIndex,
                                                        values,
                                                        arrIndex
                                                      )
                                                    )}
                                                  {row.duplicateInside && Permissons && (
                                                    <div className="mb-3 col-12 text-right">
                                                      <ButtonGroup>
                                                        {arrIndex > 0 && (
                                                          <Button
                                                            type="link"
                                                            icon={<MinusCircleOutlined />}
                                                            size="small"
                                                            className="eb_kyc_button_remove"
                                                            onClick={() => fields.remove(arrIndex)}
                                                          >
                                                            {trb(i18.Buttons.RemoveBlocks)}
                                                          </Button>
                                                        )}
                                                        {(row.maxRows === undefined ||
                                                          arrIndex < row.maxRows) && (
                                                          <Button
                                                            type="link"
                                                            icon={<PlusCircleOutlined />}
                                                            size="small"
                                                            disabled={
                                                              row.maxRows &&
                                                              fields.length > row.maxRows
                                                            }
                                                            onClick={
                                                              row.duplicateDefault
                                                                ? () =>
                                                                    fields.insert(
                                                                      arrIndex + 1,
                                                                      JSON.parse(
                                                                        JSON.stringify(
                                                                          row.duplicateDefault
                                                                        ).replace(
                                                                          "$index",
                                                                          arrIndex + 2
                                                                        )
                                                                      )
                                                                    )
                                                                : () =>
                                                                    fields.insert(arrIndex + 1, {})
                                                            }
                                                          >
                                                            {trb(i18.Buttons.DuplicateBlocks)}
                                                          </Button>
                                                        )}
                                                      </ButtonGroup>
                                                    </div>
                                                  )}
                                                </Condition>
                                                {!row.duplicateInside && Permissons && (
                                                  <div className="mb-3 col-12 text-right">
                                                    <ButtonGroup>
                                                      {arrIndex > 0 && (
                                                        <Button
                                                          type="link"
                                                          icon={<MinusCircleOutlined />}
                                                          size="small"
                                                          className="eb_kyc_button_remove"
                                                          onClick={() => fields.remove(arrIndex)}
                                                        >
                                                          {trb(i18.Buttons.RemoveBlocks)}
                                                        </Button>
                                                      )}
                                                      {(row.maxRows === undefined ||
                                                        arrIndex < row.maxRows) && (
                                                        <Button
                                                          type="link"
                                                          icon={<PlusCircleOutlined />}
                                                          size="small"
                                                          disabled={
                                                            row.maxRows &&
                                                            fields.length > row.maxRows
                                                          }
                                                          onClick={
                                                            row.duplicateDefault
                                                              ? () =>
                                                                  fields.insert(
                                                                    arrIndex + 1,
                                                                    JSON.parse(
                                                                      JSON.stringify(
                                                                        row.duplicateDefault
                                                                      ).replace(
                                                                        "$index",
                                                                        arrIndex + 2
                                                                      )
                                                                    )
                                                                  )
                                                              : () =>
                                                                  fields.insert(arrIndex + 1, {})
                                                          }
                                                        >
                                                          {trb(i18.Buttons.DuplicateBlocks)}
                                                        </Button>
                                                      )}
                                                    </ButtonGroup>
                                                  </div>
                                                )}
                                              </React.Fragment>
                                            ))
                                          }
                                        </FieldArray>
                                      ) : (
                                        <Condition
                                          when={row.showWhen}
                                          is={row.showIs}
                                          alwaysShow={row.elements
                                            .filter(item => item.alwaysShow)
                                            .map((item, itemIndex) =>
                                              FormFieldFill(item, itemIndex, values)
                                            )}
                                        >
                                          {row.elements &&
                                            row.elements.map((item, itemIndex) =>
                                              FormFieldFill(item, itemIndex, values)
                                            )}
                                        </Condition>
                                      )}
                                    </div>
                                  </div>
                                </Condition>
                              ))}
                          </React.Fragment>
                        ))}
                    </div>
                    {submit && currentStep === maxSteps && (
                      <div className="row my-4">
                        <div className="col-12 ant-alert ant-alert-warning ant-alert-with-description">
                          <FormField
                            name="Approve"
                            component={FormFieldType.checkboxOnly}
                            label={trb(this.props.approveSubmitText)}
                            inline={true}
                            className="mx-0 col-12 my-2"
                            onChange={() => {
                              approveSubmit = !values.Approve;
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-12">
                        <ButtonGroup>
                          {currentStep !== 0 && (
                            <Button onClick={this.prevStep} icon={<LeftOutlined />}>
                              {trb(i18.Buttons.PrevStep)}
                            </Button>
                          )}
                          {currentStep !== maxSteps && (
                            <Button
                              htmlType="submit"
                              type="primary"
                              icon={<RightOutlined />}
                            >
                              {trb(i18.Buttons.NextStep)}
                            </Button>
                          )}
                          {currentStep === maxSteps && submit && (
                            <Button
                              htmlType="submit"
                              type="primary"
                              icon={<SaveOutlined />}
                              disabled={!values.Approve || !Permissons}
                            >
                              {trb(i18.Buttons.Submit)}
                            </Button>
                          )}
                        </ButtonGroup>
                      </div>
                    </div>
                    <FormSpy subscription={{ values: true }}>
                      {({ values }) => {
                        this.props.onStepSubmit(values, currentStep);
                        return <></>;
                      }}
                    </FormSpy>
                    {false && this.props.finalData && (
                      <pre className="row">{JSON.stringify(this.props.finalData, null, 2)}</pre>
                    )}
                  </form>
                );
              }}
            />
            <div className="position-relative d-flex flex-row bbs_kyc_form_right_column">
              {(currentStep == 0 || currentStep == 1 || currentStep == 3) && (
                <div className="info-bubble-wrapper">
                  <div
                    className={`info-bubble ${
                      hideDescriptions && hideDescriptions.indexOf(currentStep) > -1 ? "d-none" : ""
                    }`}
                  >
                    {trb(translationGroups.StepsDescription + `Step${currentStep}`)}
                    {currentStep == 0 && (
                      <Button
                        onClick={this.hideDescription}
                        type="link"
                        size="small"
                        className="info-bubble-close"
                      >
                        ×
                      </Button>
                    )}
                  </div>
                  <div>
                    <img src="/images/notify/1-x.svg" />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {isExtraCheckModalVisible && (
          <ExtraCheckModal
            visible={isExtraCheckModalVisible}
            onOk={() => this.onExtraCheckModalOk()}
            onCancel={() => this.onExtraCheckModalCancel()}
            data={this.getExtraCheckData()}
          />
        )}
      </div>
    );
  }
}
